<template>
    <div id="hero" class="container-fluid p-0 m-0">

        <div id="scene">

            <div data-depth="0.05" class="big-planet">
                <img src="../../assets/imgs/landing/hero-planeta-periutelor-2.png" alt="" class="img-fluid">
            </div>

            <div class="dintica-hero" data-depth="0.8">
                <img src="../../assets/imgs/landing/hero-dintica.png" alt="" class="img-fluid"
                     id="dintica-hero">
            </div>

            <div data-depth="0.02" class="small-planet">
                <img src="../../assets/imgs/landing/hero-planeta-zana.png" alt="" class="img-fluid">
            </div>

            <div class="spaceship p-1 p-sm-2" data-depth="0.1">
                <img src="../../assets/imgs/landing/hero-nava.png" alt="" class="mb-0 mt-auto img-fluid">
            </div>

            <div class="d-flex flex-column w-lg-60 px-3 text-center title-container mt-3 mt-lg-5">
                <h1 class="title mt-3 d-flex flex-column justify-content-center align-items-center">

                    <span class="small">Tuti îți spune bun venit în</span>
                    <span class="d-flex flex-row flex-wrap flex-xl-no-wrap justify-content-center align-items-center big">
                        <span class="mr-2">Academia Spațială</span>
                        <span class="d-flex flex-row flex-no-wrap text-center justify-content-center align-items-center"> Dr. Leahu!</span>
                    </span>
                </h1>
            </div>

            <div class="footer">
                <img src="../../assets/imgs/landing/background-footer.png" alt="" class="img-fluid">
            </div>
        </div>

        <!--<div>-->
        <!--<button data-toggle="modal" data-target="#video" class="video-button">-->
        <!--<img src="../../assets/imgs/landing/button-play.png" alt="" class="mt-3 img-fluid button-play">-->
        <!--<h6 class="pt-2 pt-lg-4">-->
        <!--Urmărește filmulețul-->
        <!--</h6>-->
        <!--</button>-->
        <!--</div>-->

        <!--<video-modal></video-modal>-->
        <video-hero></video-hero>

    </div>
</template>

<script>
    import Parallax from 'parallax-js'
    import anime from 'animejs/lib/anime.js';

    // import VideoModal from '../partials/VideoModal'
    import VideoHero from '../partials/VideoHero'

    export default {
        name: "Hero",
        components: {VideoHero},
        mounted() {

            //parallax
            var scene = document.getElementById('scene');
            var parallaxInstance = new Parallax(scene, {
                relativeInput: true,
                clipRelativeInput: true,
            });
            parallaxInstance.friction(0.1, 0.1);

            //anime
            anime({
                targets: '#dintica-hero',
                direction: 'alternate',
                translateY: [100, 150],
                translateX: 20,
                duration: 4000,
                easing: 'linear',
                loop: true
            });

            const $ = window.$;

            window.onload = () => {
                let offsetTop = $('#scene .title-container').outerHeight(true) + parseInt($('#scene .title-container').css('top')) + 15;
                $('#video-hero').css('top', offsetTop);
                $('#video-hero').css('opacity', '1');
                $('#video-hero').css('transition', 'opacity 0.2s linear');
            };

            window.addEventListener("resize", function () {
                let offsetTop = $('#scene .title-container').outerHeight(true) + parseInt($('#scene .title-container').css('top')) + 15;
                $('#video-hero').css('top', offsetTop);
            });


        },
    }
</script>

<style lang="scss">
</style>
